import { NavLink } from "react-router-dom";
import {AiOutlineMenu,AiOutlineClose,AiOutlineShoppingCart,AiFillSetting} from "react-icons/ai";
import { RiArrowDropDownLine, RiLogoutCircleLine, RiProductHuntFill } from "react-icons/ri";
import { FaClipboardList } from "react-icons/fa";
import { CgProfile } from "react-icons/cg";
import { useState, useEffect, useRef } from "react";
import { useCookies } from 'react-cookie';
import Logo from "../photos/Logo.png";
import Cart from "./Cart";
import Avatar from 'react-avatar';
import { useNavigate } from 'react-router-dom';
import useFetchWithAuthorization from "../Apis/useFetchWithAuthorization";

const Header = ({ cartItems, handleRemoveFromCart, handleRemoveAllFromCart }) => {
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies(['token']);
  const [user, setUser] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };


  

  const { data, loading, error } = useFetchWithAuthorization("https://campus-closet-server.vercel.app/profile");
  useEffect(() => {
    if (data) {
      setUser(true);
    }
  }, [data]);

  // Handle the error state here (e.g., show an error message)
  useEffect(() => {
    if (error) {
      console.log("Error :", error);
    }
  }, [error]);
  
  const [showMenu, setShowMenu] = useState(false);
  const [modal, setModal] = useState(false);
  const navbarRef = useRef();
  const cartRef = useRef();


  //The Profile drop down to disappear when outside it is clicked
  useEffect(() => {
    const handleClickOutside = (event) => {
      if(
        (navbarRef.current && !navbarRef.current.contains(event.target))  || 
        (cartRef.current && cartRef.current.contains(event.target))
        ){
        setShowMenu(false);
        setShowDropdown(false); // Hide the dropdown when clicking outside
        setModal(false)
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  //Show and hide cart when clicked
  const handleClick = () => {
    setModal(!modal)
  };
  const hideCart=()=>{
    setModal(!modal)
  }



  const handleShowMenu = () => {
    setShowMenu(true);
  };

  const handleHideMenu = () => {
    setShowMenu(false);
  };
  const handleLogout = () => {
    removeCookie('token'); // Delete the 'token' cookie
    setUser(false)
    navigate('/login'); // Navigate to the "/" route
  };


  
  return (
    <section>
      <nav
        ref={navbarRef}
        className="flex justify-between bg-slate-100 h-14 p-3 items-center border-b-2"
      >
        <div className="logo">
          <AiOutlineMenu
            onClick={handleShowMenu}
            id="menu-icon"
            className="mt-2 mr-2 lg:hidden"
            size={26}
          />
          <div className="">
            <img src={Logo} className="h-12" alt="Campus Closet" />
          </div>
        </div>
        <ul
          className={`${
            showMenu ? " block" : "hidden"
          } lg:flex justify-between space-x-5 lg:space-x-8 navlink`}
        >
          <AiOutlineClose
            onClick={handleHideMenu}
            id="menu-close-icon"
            size={26}
            className="cursor-pointer mt-2 mr-2 lg:hidden"
          />
          <li>
            <NavLink exact="true" to="/" onClick={handleHideMenu}>
              Home
            </NavLink>
          </li>
          <li>
            <NavLink to="households" onClick={handleHideMenu}>
              Households
            </NavLink>
          </li>
          <li>
            <NavLink to="electronics" onClick={handleHideMenu}>
              Electronics
            </NavLink>
          </li>
          <li>
            <NavLink to="furniture" onClick={handleHideMenu}>
              Furniture
            </NavLink>
          </li>
          <li>
            <NavLink to="others" onClick={handleHideMenu}>
              Others
            </NavLink>
          </li>
          <li>
            <NavLink to="contacts" onClick={handleHideMenu}>
              Contact Us
            </NavLink>
          </li>
          <li>
            <NavLink to="about" onClick={handleHideMenu}>
              About
            </NavLink>
          </li>
        </ul>
        <div className="flex space-x-4 mx-2 ">
          {user && <div className="flex items-center">
            <FaClipboardList className="mt-2 cursor-pointer" size={26} onClick={()=>navigate("/order/myorders")} />
          </div>}
          <div onClick={handleClick} className="flex items-center">
            <AiOutlineShoppingCart className="mt-2 cursor-pointer" size={26} />
            {cartItems && cartItems.length > 0 && (
              <div className="-ml-2 bg-orange-500 rounded-lg h-4 w-5 flex justify-center items-center">
                <p className="text-xs cursor-pointer">{cartItems.length}</p>
              </div>
            )}
          </div>
          <div className="flex space-x-4 mx-2 ">
            {user ? (
              <>
                <div className="flex md:space-x-2 relative">
                  <div to="#" className="mt-2 flex">
                    {/* <CgProfile size={30} /> */}
                    <Avatar  className="w-1 h-1 rounded-full" name={data.user.name} 
                      size={30}
                    />
                    <RiArrowDropDownLine
                      size={30}
                      className="cursor-pointer"
                      onClick={toggleDropdown}
                    />
                    {showDropdown && (
                      <div className="absolute w-52 h-auto top-12 right-0 bg-white border border-gray-300 rounded-md shadow-md">
                        <ul className="m-2 space-y-2 mt-5 ">
                          <li className="flex space-x-2 hover:border-b-2 cursor-pointer">
                          <CgProfile size={20} />
                            <NavLink to="/profile">My Account</NavLink>
                          </li>
                          {/* <li className="flex space-x-2 hover:border-b-2 cursor-pointer">
                          <AiFillSetting size={20}/>
                            <p>Settings</p>
                          </li> */}
                          {/* <li className="flex space-x-2 hover:border-b-2 cursor-pointer">
                          <RiProductHuntFill size={20}/>
                            <NavLink to="/myproducts">My Products</NavLink>
                          </li> */}
                          <li className="flex space-x-2 hover:border-b-2 cursor-pointer">
                          <RiProductHuntFill size={20}/>
                            <NavLink to="/admin">My Market</NavLink>
                          </li>
                          {/* <li className="flex space-x-2 hover:border-b-2 cursor-pointer">
                          <RiProductHuntFill size={20}/>
                            <NavLink to="/order/client">My Orders</NavLink>
                          </li> */}
                          <li onClick={handleLogout} className="flex space-x-2 hover:border-b-2 cursor-pointer">
                            <RiLogoutCircleLine size={20}/>
                            <p>Logout</p>
                          </li>
                        </ul>
                      </div>
                      
                    )}
                  </div>
                  <div>
                    <p className="mt-3 text-green-600 font-bold">Welcome! </p>
                    {/* <span className="text-sm">{data.user.name.slice(0, data.user.name.indexOf(' '))}</span> */}
                  </div>
                </div>
              </>
           ) : loading ? (
            <p>Loading...</p>
          ) : (
              <>
              <div className="flex space-x-4 mx-2 profile ">
                <p className="mt-2 ">
                  <NavLink to="/login">Login</NavLink>
                </p>
                <p className="mt-2">
                  <NavLink to="/register">Register</NavLink>
                </p>
              </div>
              </>
            )}
          </div>
        </div>
      </nav>
      {/* <div className="flex justify-center md:justify-normal">
        <input
          type="text"
          placeholder="Search items..."
          className="py-1 mt-2 md:ml-auto mr-2 px-4 w-72 md:w-96 rounded-md border-2 border-gray-400 focus:outline-none focus:border-blue-500"
        />
        <div className="flex items-center">
          <FaSearch className="text-gray-500" />
        </div>
      </div> */}
      {modal ? (
        <div ref={cartRef}>
        <Cart
          // cartItems={cartItems}
          //  setCartItem={setCartItems}
          handleRemoveFromCarts={handleRemoveFromCart}
          handleRemoveAllFromCart={handleRemoveAllFromCart}
          hidecart={hideCart}
        />
      </div>
      ) : null}
    </section>
  );
};

export default Header;
